import { Injector, ApplicationRef, Component, OnInit, ComponentFactoryResolver, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { timer } from "rxjs";
import { AppConfig } from "../../../../config/app.config";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DashboardVisitorService } from "../dashboard-visitor.service";
import { DistrictStatsYTDComponent } from "../district-stats-ytd/district-stats-ytd.component";
import { FacilityStatsYTDComponent } from "../facility-stats-ytd/facility-stats-ytd.component";
import { VisitorPreferenceRequest } from "../Info/VisitorPreferenceRequest";
import { TodaysVisitorStatsComponent } from "../todays-visitor-stats/todays-visitor-stats.component";
import { VisitorDeniedComponent } from "../visitor-denied/visitor-denied.component";
import { VisitorGraphComponent } from "../visitor-graph/visitor-graph.component";

@Component({
	selector: "caass-dashboard-visitor",
	templateUrl: "./dashboard-visitor.component.html",
	styleUrls: ["./dashboard-visitor.component.css"],
})
export class DashboardVisitorComponent {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private dashboardService: DashboardVisitorService,
		private config: AppConfig,
		private router: Router,
		private userService: UserService
	) {}

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.RefreshTimer = timer(this.RefreshSeconds * 1000, this.RefreshSeconds * 1000);
		this.Refresher = this.RefreshTimer.subscribe((val) => {
			this.onRefresh();
		});

		this.loadPreferences();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
			this.SelectedSchoolNumber = school.SchoolNumber;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
		this.Refresher.unsubscribe();

		this.UpdatePreferences();
	}

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////

	user: any;
	subscription: any;

	SelectedSchoolID: any; /////
	SelectedSchoolNumber: any = "0";

	LoadingFacility: any = true;
	FacilityID: any;
	lstFacility: any = [];

	LoadingPreference: any = true;
	FacilityStatPanel: string;
	DistrictStatPanel: string;
	GraphPanel1: number;
	GraphPanel2: number;

	@ViewChild(TodaysVisitorStatsComponent)
	todaysVisitorsRef: TodaysVisitorStatsComponent;

	@ViewChild(VisitorDeniedComponent)
	deniedVisitorsRef: VisitorDeniedComponent;

	@ViewChild(FacilityStatsYTDComponent)
	facilityRef: FacilityStatsYTDComponent;

	@ViewChild(DistrictStatsYTDComponent)
	districtRef: DistrictStatsYTDComponent;

	@ViewChild("Panel1")
	graphPanel1Ref: VisitorGraphComponent;

	@ViewChild("Panel2")
	graphPanel2Ref: VisitorGraphComponent;

	Refresher: any;
	RefreshTimer: any;
	RefreshSeconds: any = 300; //5 Minutes

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////

	loadFacility() {
		this.LoadingFacility = true;

		if (this.SelectedSchoolID == undefined) {
			return;
		}

		var result = this.dashboardService.FacilitySelectList(this.SelectedSchoolID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				if (this.lstFacility.length > 0) {
					this.FacilityID = this.lstFacility[0].FacilityID;
				}

				this.LoadingFacility = false;
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadPreferences() {
		this.LoadingPreference = true;

		var result = this.dashboardService.VisitorPreferenceSelect(this.user.personID);
		result.subscribe(
			(response) => {
				var data: any = response[0];

				if (data != undefined) {
					// FacilityStatPanel
					// DistrictStatPanel
					// GraphPanel1
					// GraphPanel2

					this.FacilityStatPanel = data.FacilityStatPanel == undefined ? "WTD" : data.FacilityStatPanel;
					this.DistrictStatPanel = data.DistrictStatPanel == undefined ? "WTD" : data.DistrictStatPanel;
					this.GraphPanel1 = data.GraphPanel1 == undefined ? 1 : data.GraphPanel1;
					this.GraphPanel2 = data.GraphPanel2 == undefined ? 1 : data.GraphPanel2;
				} else {
					this.FacilityStatPanel = "WTD";
					this.DistrictStatPanel = "WTD";
					this.GraphPanel1 = 1;
					this.GraphPanel2 = 2;
				}

				this.LoadingPreference = false;
			},
			(error) => {
				this.LoadingPreference = false;
			}
		);
	}

	UpdatePreferences() {
		try {
			if (this.facilityRef != undefined && this.districtRef != undefined && this.graphPanel1Ref != undefined && this.graphPanel2Ref != undefined) {
				let fStatPanel = "WTD";
				if (this.facilityRef.OptionID == 1) {
					fStatPanel = "MTD";
				} else if (this.facilityRef.OptionID == 2) {
					fStatPanel = "YTD";
				}

				let dStatPanel = "WTD";
				if (this.districtRef.OptionID == 1) {
					dStatPanel = "MTD";
				} else if (this.districtRef.OptionID == 2) {
					dStatPanel = "YTD";
				}

				let gPanel1 = this.graphPanel1Ref.Option.ID;
				let gPanel2 = this.graphPanel2Ref.Option.ID;

				let parms: VisitorPreferenceRequest = {
					FacilityStatPanel: fStatPanel,
					DistrictStatPanel: dStatPanel,
					GraphPanel1: gPanel1,
					GraphPanel2: gPanel2,
					PersonID: this.user.personID,
				};

				var result = this.dashboardService.VisitorPreferenceUpdate(parms);
				result.subscribe(
					(response) => {
						if (response) {
						} else {
						}
					},
					(error) => {}
				);
			}
		} catch (e) {
			e.toString();
		}
	}

	onRefresh() {
		this.todaysVisitorsRef.loadData();
		this.deniedVisitorsRef.loadVisitorLog();
		this.facilityRef.loadData();
		this.districtRef.loadData();
		this.graphPanel1Ref.loadData();
		this.graphPanel2Ref.loadData();
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Events
	///////////////////////////////////////////
	onSchoolChange(val) {
		this.SelectedSchoolID = val;

		this.loadFacility();
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////

	IsLoading() {
		return this.LoadingFacility == true || this.LoadingPreference == true;
	}

	///////////////////////////////////////////
}
